var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-2-bio',{attrs:{"section":2,"page":4,"index":3}})}
var staticRenderFns = []

export { render, staticRenderFns }